<template>
  <v-card class="py-2">
    <v-icon v-on:click.stop="$emit('close')" large class="closeIcon mt-3 mx-2"
      >mdi-close</v-icon
    >
    <h2
      weight="200"
      class="mt-6 d-flex font-weight-regular justify-center align-center"
    >
      Ajouter un dossier au dossier "{{ parent.name }}"
    </h2>
    <v-divider light color="#EF7D00" class="mt-4 mb-6 mx-4"></v-divider>
    <v-form
      ref="form"
      v-model="isFormValid"
      class="d-flex flex-column px-10 py-4"
    >
      <v-row>
        <v-text-field
          v-model="name"
          label="Nom du dossier"
          prepend-icon="mdi-file-document"
          required
          :rules="name_rule"
        ></v-text-field>
      </v-row>
      <v-row class="d-flex align-center">
        <v-col>Visibilté : </v-col>
      </v-row>
      <div v-for="field in visibilityFields" :key="field.key" class="ml-4 mb-2">
        <v-autocomplete
          v-model="visibility[field.key]"
          :items="field.items"
          :label="field.label"
          :prepend-icon="field.icon"
          :rules="field.rules"
          multiple
          dense
        >
          <template v-slot:selection="{ item }">
            <v-chip
              close
              class="mx-1 my-1"
              @click:close="removeVisibilityItem(field.key, item)"
            >
              {{ item }}
            </v-chip>
          </template>
        </v-autocomplete>
      </div>
    </v-form>
    <ValidateErrorButtons
      @successClicked="validate()"
      @errorClicked="$emit('close')"
      :disabled="!isFormValid"
    >
      <template v-slot:error>ANULER</template>
      <template v-slot:success>VALIDER</template>
    </ValidateErrorButtons>
  </v-card>
</template>

<script>
import ValidateErrorButtons from "../../components/ValidateErrorButtons.vue";

const API_TO_UI_ROLES = { teacher: "Tuteur", student: "Tutoré" };
const UI_TO_API_ROLES = { Tuteur: "teacher", Tutoré: "student" };

export default {
  name: "DialogAddDirectory",
  components: {
    ValidateErrorButtons,
  },
  props: {
    parent: Object,
  },
  data: () => ({
    isFormValid: false,
    name: "",
    visibility: {
      roles: [],
      schools: [],
      years: [],
    },
  }),
  computed: {
    name_rule: function () {
      return [
        !!this.name || "Le nom ne peut pas être vide",
        !this.parent.children.directories
          .map((i) => i.name.toLowerCase())
          .includes(this.name.toLowerCase()) ||
          "ce nom est déjà utilisé par un autre dossier",
      ];
    },
    visibilityFields() {
      return [
        {
          key: "roles",
          label: "Rôles",
          icon: "mdi-book",
          items: ["Tuteur", "Tutoré"],
          rules: this.createVisibilityRules("roles", "rôle"),
        },
        {
          key: "schools",
          label: "Écoles",
          icon: "mdi-school",
          items: ["ESILV", "EMLV", "IIM"],
          rules: this.createVisibilityRules("schools", "école"),
        },
        {
          key: "years",
          label: "Années",
          icon: "mdi-cake",
          items: ["A1", "A2", "A3", "A4", "A5"],
          rules: this.createVisibilityRules("years", "année"),
        },
      ];
    },
  },
  methods: {
    validate: function () {
      let payload = {
        name: this.name,
        parent: this.parent._id,
        visibility: {
          roles: this.visibility.roles.map((r) => UI_TO_API_ROLES[r]),
          schools: this.visibility.schools,
          years: this.visibility.years,
        },
      };
      this.$store.dispatch("leodata/createDirectory", payload).then(() => {
        this.name = "";
        this.$emit("close");
      });
    },
    createVisibilityRules(key, singularName) {
      if (!this.parent?.visibility) return [true];

      let parentVisibilityItems = [];
      if (key === "roles") {
        parentVisibilityItems =
          this.parent.visibility.roles?.map((r) => API_TO_UI_ROLES[r] || r) ||
          [];
      } else {
        parentVisibilityItems = this.parent.visibility[key] || [];
      }

      return [
        (v) => {
          const errors = (v || []).filter(
            (item) => !parentVisibilityItems.includes(item)
          );
          if (errors.length === 0) return true;
          const plural = errors.length > 1;
          return `Le${plural ? "s" : ""} ${singularName}${
            plural ? "s" : ""
          } "${errors.join(", ")}" n'est pas permis par le dossier parent.`;
        },
      ];
    },
    removeVisibilityItem(key, item) {
      const index = this.visibility[key].indexOf(item);
      if (index >= 0) this.visibility[key].splice(index, 1);
    },
    initializeForm() {
      if (this.parent?.visibility) {
        this.visibility.roles =
          this.parent.visibility.roles?.map((r) => API_TO_UI_ROLES[r]) || [];
        this.visibility.schools = [...(this.parent.visibility.schools || [])];
        this.visibility.years = [...(this.parent.visibility.years || [])];
      } else {
        this.visibility = { roles: [], schools: [], years: [] };
      }
    },
  },
  created() {
    this.initializeForm();
  },
  watch: {
    parent(newValue) {
      if (newValue) {
        this.initializeForm();
      }
    },
  },
};
</script>
<style scoped>
.v-sheet {
  position: relative;
  color: #8f8f8f;
}
.v-icon,
.v-input {
  color: #8f8f8f;
}
.closeIcon {
  position: absolute;
  right: 0;
  top: 0;
}

.discord_link {
  color: inherit;
}
</style>
